<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";
import { useImage, useListItem, useUploadImage } from "@/hooks";
const props = defineProps<{ property: string; src?: string }>();
const { item } = useListItem();
const { imageUrl } = useUploadImage(
  computed(() => (item.value ? item.value[props.property] : undefined))
);
const { imageUrl: bgUrl } = useImage(computed(() => props.src));
</script>
<template>
  <PreviewableImage
    class="mp-list-uploaded-image"
    :src="imageUrl || bgUrl"
    v-bind="$attrs"
  />
</template>
